const theme = {
    background: '#ffde59',
    primaryColor: '#ffde59',
    secundaryColor: '#332E5A',
    black:'#000000',
    white: '#ffffff',
    green: '#31a184',
    red: '#ff3131',
    textColor: '#ffffff',
    blue: '#332E5A'
}

export default theme;